const mixin = {
  data() {
    return {
      savedTag: false
    }
  },
  methods: {},
  created() {
    window.onbeforeunload
  },

  beforeRouteLeave(to, from, next) {
    if (!this.savedTag) {
      var answer = confirm(this.$t("Messages.__LeavePageAlert"))
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}

export { mixin }
